import React from 'react'
import "./RegistrationCourse.css"; // עיצוב חיצוני
import { formatActivityDay,convertToIsraelTime, formatActivityDayoz } from '../../util/formatsForDate';

const RegistrationCourse = ({ onClose, course, onNext }) => {
  
  return (
    <div className="popup-overlay ">
      <div className="popup-content">
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
<div className='max-h-[80vh] overflow-y-scroll'>
        <img
          src={course?.mySelfQualificationDto?.linkImage?`https://archivebureau.s3.eu-west-3.amazonaws.com/${course?.mySelfQualificationDto?.linkImage}` :"https://images.pexels.com/photos/4391470/pexels-photo-4391470.jpeg"}
          alt="תמונה"
          className="popup-image"
        />

        <h3 className="popup-title">
          {/* רשימת מתנה לפוליסת האחריות המקצועית של לשכת ממוני הבטיחות */}
          {course?.mySelfQualificationDto?.name}
        </h3>
{/* 
        <p className="popup-description">
          ביום עיון נלמד, על אילו תחומים חלה פוליסת הבטיחות בעבודה:
          <br />
          • חידוש חוק, תקנות ונהלים רלוונטיים לממונה בטיחות <br />
          • ניהול סיכונים ודרכי מניעה <br />
          • דגשים חשובים בניהול מערכות בטיחות <br />
          • ועוד...
        </p> */}
        <p className="popup-description text-right whitespace-pre-line">
          {course?.mySelfQualificationDto?.description}
        
        </p>
{console.log("first:"+course?.mySelfQualificationDto?.description)}
        <p className="popup-details text-right whitespace-pre-line">
          {course?.mySelfQualificationDto?.activityDays?.length>0 &&
          <>
            <b>מתי המפגש:</b>
            <br />
              {course?.mySelfQualificationDto?.activityDays.map((activityDay,index) => { return formatActivityDayoz(activityDay) })}
              <br />
          </>
          }
          {/* יום רביעי 15:00-20:00 <br />
          התכנסות: 10:00 <br /> */}
         
          <b>מיקום:</b> {course?.mySelfQualificationDto?.place} <br />
          {/* <b>עלות:</b> {course?.product?.price} ₪<br /> */}
          <b>עלות:</b> {course?.lastPrice} ₪<br />
          <b> תאריך הכשרה:</b> {convertToIsraelTime(course?.mySelfQualificationDto?.startDate)} <br />
          <b>מספר מפגשים:</b>{course?.daysWork==1? " 1 מפגש":course?.daysWork==0? " -": ` ${course?.daysWork} מפגשים`}
        </p>

        <button className="register-btn" onClick={onNext} disabled={course?.isRegistered}>{course?.isRegistered?"הינך רשומ/ה":"מעבר להרשמה"}</button>
      </div>
      </div>
    </div>
  )
}

export default RegistrationCourse